import { render, staticRenderFns } from "./KeywordDetail.vue?vue&type=template&id=3a51fef7"
import script from "./KeywordDetail.vue?vue&type=script&lang=js"
export * from "./KeywordDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports